/**
 * Column-presets domain — utility types and mappers.
 *
 * Re-exports the legacy `ColumnPreset` model type (defined in
 * `models/column_preset.ts`) so consumers can import it from the
 * domain entry point alongside the hooks. The legacy interface
 * already narrows `payload` to `Column[]` and `identifier` to
 * `FilterIdentifier`, which is more accurate than the generated
 * `ColumnOrderPreset.payload: any` / `identifier: string` —
 * keeping a single shared type avoids the nominal-collision issues
 * two distinct definitions cause when consumers pass values across
 * module boundaries.
 */

export type { ColumnPreset } from '../../models/column_preset'

import type { ColumnPreset } from '../../models/column_preset'
import type { ColumnOrderPreset } from '../generated/types/ColumnOrderPreset'

/** Mirrors the legacy hook's `{ label, value, original }` shape. */
export interface ColumnPresetOption {
  label: string
  value: number
  original: ColumnPreset
}

/**
 * Narrow a generated `ColumnOrderPreset` to the domain `ColumnPreset`.
 *
 * The two structurally describe the same wire payload, but the
 * generated type widens `identifier` to `string` and `payload` to
 * `any`. This mapper is the single point in the codebase where that
 * widening is reversed — if Kubb ever drops a field that the legacy
 * `ColumnPreset` requires, the cast moves into one place that's easy
 * to inspect rather than scattering across hooks. There is no runtime
 * transformation, only a type assertion.
 */
export function toColumnPreset(generated: ColumnOrderPreset): ColumnPreset {
  return generated as unknown as ColumnPreset
}
